<template>
    <div>
       <!-- 关联故障 -->
        <el-table :data="detail.toProblem">

            <el-table-column label="编号" prop="serialNumber"></el-table-column>

            <el-table-column label="标题" prop="title"></el-table-column>

            <el-table-column label="部门" prop="department"></el-table-column>

            <el-table-column label="问题分类" prop="category"></el-table-column>

            <el-table-column label="报告人" prop="requester"></el-table-column>

            <el-table-column label="指派人" prop="designator"></el-table-column>

            <el-table-column label="创建时间" prop="createTime"></el-table-column>
            
        </el-table>
    </div>
</template>

<script>
   
export default {
    props: {
        detail: {
            type: Object
        }
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
   
</style>